import * as React from 'react';
import axios from 'axios';
import BttfAxios from '@features/utils/axios';
import Collaborator from '@company/components/Collaborator/Collaborator';
import CollaboratorsSearch from '@company/components/CollaboratorsSearch/CollaboratorsSearch';
import { ICollaboratorsProps } from './ICollaboratorsPage';
import { ICollaborator } from '@company/components/Collaborator/ICollaborator';
import { ICollaboratorsSearchValues } from '@company/components/CollaboratorsSearch/ICollaboratorsSearch';
import noPhotoMale from '@images/no_photo_male.png';

import * as style from './CollaboratorsPageStyles.module.scss'
import * as appStyle from '@company/AppStyle.module.scss';

export default class Collaborators extends React.Component<ICollaboratorsProps> {

  state = { collaborators: [], organizations: [] };

  componentDidMount() {
    BttfAxios.get(`/api/companies/${this.props.companyId}/collaborators`, (res) => {
      this.setState({ collaborators: res.data });
    });
  }

  showInvitedCollaborators() {
    const collaboratorsUnverified: any = [];
    const collaboratorsVerified: any = [];

    this.state.collaborators.forEach((elem: ICollaborator) => {
      const array = elem.verified ? collaboratorsVerified : collaboratorsUnverified;
      array.push(
        <Collaborator
          key={elem.id}
          id={elem.id}
          profile_id={elem.profile_id}
          name={elem.name}
          companyId={this.props.companyId}
          avatar={elem.avatar ? elem.avatar : noPhotoMale}
          verified={elem.verified}
          deleteCollaborator={this.deleteCollaborator}
        />
      );
    });

    return (
      <React.Fragment>
        {collaboratorsUnverified.length > 0 && <h2>Already Invited</h2>}
        {collaboratorsUnverified}
        {collaboratorsVerified.length > 0 && <h2>Collaborators</h2>}
        {collaboratorsVerified}
      </React.Fragment>
    );
  }

  deleteCollaborator = (id: number) => {
    if (confirm('Are you sure?')) {
      axios.delete(`/api/companies/${this.props.companyId}/collaborators/${id}`)
        .then((res) => {
          if (res.status === 204) {
            this.setState({
              collaborators: [
                ...this.state.collaborators.filter((elem: ICollaborator) => {
                  return elem.id !== id;
                }),
              ],
            });
          }
        });
    }
  }

  private renderOrganizationError = () => {
    return (
      <p className={`${appStyle.errorText}  ${style.organizationalError}`}>
        Error:  Institutional users cannot be added as a collaborators: {this.state.organizations.join(', ')}.
      </p>
    );
  }

  invitePeople = (people: ICollaboratorsSearchValues[]) => {
    const data:{emails: string[]; slugs: string[]} = { emails: [], slugs: [] };
    people.forEach((elem) => {
      if (elem.isEmail) {
        data.emails.push(elem.value);
      } else {
        data.slugs.push(elem.value);
      }
    });

    BttfAxios.post(`/api/companies/${this.props.companyId}/collaborators`, data, (res) => {

      this.setState({
        collaborators: [
          ...this.state.collaborators,
          ...res.data.collaborators,
        ],
        organizations: [
          ...res.data.organizations
        ]
      });
    });
  }

  render() {
    return (
      <div className={style.collaboratorsPageContainer}>
        <div className={style.collaboratorsPage}>
          <CollaboratorsSearch invitePeople={this.invitePeople} organizations={this.state.organizations} companyId={this.props.companyId} />
          {this.state.organizations.length !== 0 && this.renderOrganizationError()}
          {this.showInvitedCollaborators()}
        </div>
      </div>
    );
  }
}
